import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import _ from 'lodash';
import { Helmet } from 'react-helmet';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import './index.scss';
import BlogPosts from '../../NewBlogPosts';
import { BLOCKS } from '@contentful/rich-text-types';
import { HOME_CANONICAL } from '../../../constants/defaults';
import AuthorInfo from '../../common/AuthorInfo';
const PressReleaseArticle = props => {
  let data;
  if (typeof window !== 'undefined' && typeof __INITIAL_DATA__ !== 'undefined')
    data = window.__INITIAL_DATA__;
  else data = props.staticContext.data;
  const content = JSON.parse(data.mainContent);
  const renderOptions = links => {
    const entryBlockMap = new Map();

    if (links && !_.isEmpty(links.entries)) {
      for (const entry of links.entries.block) {
        entryBlockMap.set(entry.sys.id, entry);
      }
    }
    const assetBlockMap = new Map();
    if (links && !_.isEmpty(links.assets)) {
      for (const asset of links.assets.block) {
        assetBlockMap.set(asset.sys.id, asset);
      }
    }
    return {
      renderNode: {
        [BLOCKS.EMBEDDED_ENTRY]: node => {
          const entry = entryBlockMap.get(node.data.target.sys.id);
          return (
            <span
              dangerouslySetInnerHTML={{
                __html: entry.tableData
              }}
            ></span>
          );
        },
        [BLOCKS.EMBEDDED_ASSET]: node => {
          const asset = assetBlockMap.get(node.data.target.sys.id);
          return <img className="contentImg" src={asset.url} alt="" />;
        }
      }
    };
  };
  const getMetaData = () => {
    return (
      <Helmet>
        <title>{data && data.metaTitle}</title>
        <link
          rel="canonical"
          href={
            data.canonicalTag && data.canonicalTag.length > 0
              ? `${HOME_CANONICAL}/${data.canonicalTag}`
              : `${HOME_CANONICAL}/press/${data && data.urlSlug}`
          }
        />
        <meta name="description" content={data && data.metaDescription} />
        <meta property="og:type" content={data && data.ogType} />
        <meta property="og:title" content={data && data.ogTitle} />
        <meta property="og:description" content={data && data.ogDescription} />
        <meta property="og:image" content={data && data.ogImage} />
        <meta
          property="og:url"
          content={`https://www.singlecare.com${props.location.pathname}`}
        />
        <meta property="og:site_name" content="SingleCare" />
        {!_.isEmpty(data) && !data.metaRobotsIndex && (
          <meta
            name="ROBOTS"
            content="NOINDEX, FOLLOW, NOSNIPPET, NOODP, NOYDIR"
          />
        )}
      </Helmet>
    );
  };
  return (
    <>
      <div className="pressCenterArticles">
        {getMetaData()}
        <div className="articlesContiner">
          <div className="backToLink">
            <a href="/press">
              <LazyLoadImage
                src="/content/images/icons/blue-arrow-left.svg"
                alt="arrow"
                height="19px"
                width="18px"
              />
              <span>Back to Press Center</span>
            </a>
          </div>
          <LazyLoadImage
            src={data && data.imageUrl}
            className="articleImageUrl"
          />
          <h1>{data && data.articleNameHeadline}</h1>
          {data && data.authors[0] && (
            <AuthorInfo
              author={data.authors[0]}
              publishDate={data.publishDate}
              cssClass="articleInfo"
              cssDataClass="articleInfoData"
            />
          )}
          <div className="mainArticleData">
            {documentToReactComponents(
              content.json,
              renderOptions(content.links)
            )}
          </div>
        </div>
      </div>
      <div className="homepage-new">
        <BlogPosts />
      </div>
    </>
  );
};
export default PressReleaseArticle;
